import axios from 'axios';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import geografiaFunciones from '../function/geografia.Funciones';
import { generarEdades, generarGruposSanguineos, generarSexos } from '../function/listascomunes.Funciones';
import { normalizeImage } from '../utils/image';

const RegistrarAprendices = () => {
    const navigate = useNavigate(); // Hook para redireccionar
    const navegarFirmaAcudiente = (idAcudiente) => {
        navigate(`/aprendiz/registrarfirma/${id}/${idAcudiente}`);
    };
    const { id } = useParams(); // Capturar el ID de la URL
    const { state } = useLocation();
    const aprendiz = state?.aprendiz;


    // Información básica del Aprendiz
    const [documentoAprendiz, setDocumentoAprendiz] = useState('');
    const [tipodocumentoAprendiz, setTipodocumentoAprendiz] = useState('');
    const [nombre1Aprendiz, setNombre1Aprendiz] = useState('');
    const [nombre2Aprendiz, setNombre2Aprendiz] = useState('');
    const [apellido1Aprendiz, setApellido1Aprendiz] = useState('');
    const [apellido2Aprendiz, setApellido2Aprendiz] = useState('');

    // Información personal
    const [fechanacimientoAprendiz, setFechanacimientoAprendiz] = useState('');
    const [edadAprendiz, setEdadAprendiz] = useState('');
    const [sexoAprendiz, setSexoAprendiz] = useState('');
    const [rhAprendiz, setRhAprendiz] = useState('');
    const [emailAprendiz, setEmailAprendiz] = useState('');

    // Información de contacto
    const [telefono1Aprendiz, setTelefono1Aprendiz] = useState('');
    const [telefono2Aprendiz, setTelefono2Aprendiz] = useState('');
    const [direccionAprendiz, setDireccionAprendiz] = useState('');

    // Ubicación del Aprendiz
    const [paises, setPaises] = useState([]);
    const [estados, setEstados] = useState([]);
    const [ciudades, setCiudades] = useState([]);

    const [paisAprendiz, setPaisAprendiz] = useState('');
    const [estadoAprendiz, setEstadoAprendiz] = useState('');
    const [ciudadAprendiz, setCiudadAprendiz] = useState('');

    const [paisSeleccionado, setPaisSeleccionado] = useState('');
    const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
    const [ciudadSeleccionada, setCiudadSeleccionada] = useState('');

    const [estudiosAprendiz, setEstudiosAprendiz] = useState([
        {
            nivel: '',
            institucion: '',
            tituloObtenido: '',
            anioFinalizacion: '',
            isAdding: true, // Indica que el estudio aún está en edición
        },
    ]);

    const [acudientesAprendiz, setAcudientesAprendiz] = useState([
        {
            nombreAcudiente: '',
            tipodocumentoAcudiente: '',
            documentoAcudiente: '',
            lugardocumentoAcudiente: '',
            relacionAcudiente: '',
            telefonoAcudiente: '',
            emailAcudiente: '',
            acudientePrincipal: false,
            isAdding: true, // Indica que el acudiente aún está en edición
        },
    ]);

    // Imagen
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState('');
    const previewRef = useRef(''); // para revocar URL
    const [uploadState, setUploadState] = useState(0);
    const [loading, setLoading] = useState(false);

    const [previewFirmaAprendiz, setPreviewFirmaAprendiz] = useState(null);
    const [previewFirmaAcudiente, setPreviewFirmaAcudiente] = useState(null);

    const [edit, setEdit] = useState(false);



    useEffect(() => {
        setEdit(!!id);
    }, [id]);

    const handleCancelOrClean = () => {
        cleanData();
        if (edit) {
            navigate("/aprendiz/listaraprendices"); // Redirigir y cambiar estado
            setEdit(false);
        }
    };

    useEffect(() => {
        let isMounted = true; // bandera para saber si el componente sigue montado

        const fetchAprendiz = async () => {
            try {
                const { data } = await axios.get(`/api/aprendices/listid/${id}`);

                if (!data.ok) {
                    console.error("Error: Aprendiz no encontrado");
                    return;
                }

                const aprendizData = data.message ?? {};

                const fechaNacimiento = aprendizData.fechanacimientoAprendiz
                    ? new Date(aprendizData.fechanacimientoAprendiz).toISOString().split('T')[0]
                    : "";

                if (!isMounted) return;

                setDocumentoAprendiz(aprendizData.documentoAprendiz ?? "");
                setTipodocumentoAprendiz(aprendizData.tipodocumentoAprendiz ?? "");
                setNombre1Aprendiz(aprendizData.nombre1Aprendiz ?? "");
                setNombre2Aprendiz(aprendizData.nombre2Aprendiz ?? "");
                setApellido1Aprendiz(aprendizData.apellido1Aprendiz ?? "");
                setApellido2Aprendiz(aprendizData.apellido2Aprendiz ?? "");
                setFechanacimientoAprendiz(fechaNacimiento);
                setEdadAprendiz(aprendizData.edadAprendiz ?? "");
                setSexoAprendiz(aprendizData.sexoAprendiz ?? "");
                setRhAprendiz(aprendizData.rhAprendiz ?? "");
                setEmailAprendiz(aprendizData.emailAprendiz ?? "");
                setTelefono1Aprendiz(aprendizData.telefono1Aprendiz ?? "");
                setTelefono2Aprendiz(aprendizData.telefono2Aprendiz ?? "");
                setDireccionAprendiz(aprendizData.direccionAprendiz ?? "");
                setPaisAprendiz(aprendizData.paisAprendiz ?? "");
                setEstadoAprendiz(aprendizData.estadoAprendiz ?? "");
                setCiudadAprendiz(aprendizData.ciudadAprendiz ?? "");

                setEstudiosAprendiz(aprendizData.estudiosAprendiz ?? []);
                setAcudientesAprendiz(aprendizData.acudientesAprendiz ?? []);

                if (aprendizData.imgAprendiz) {
                    setPreview(aprendizData.imgAprendiz);
                    previewRef.current = aprendizData.imgAprendiz; // si es URL remota no se revoca
                }

                if (aprendizData.firmaAprendiz) setPreviewFirmaAprendiz(aprendizData.firmaAprendiz);

                const listaAcudientes = aprendizData.acudientesAprendiz ?? [];
                const principal = listaAcudientes.find(a => a?.acudientePrincipal) || listaAcudientes[0];

                if (principal?._id) setSelectedAcudienteId(principal._id);
                if (principal?.firmaAcudiente) setPreviewFirmaAcudiente(principal.firmaAcudiente);
                else setPreviewFirmaAcudiente(null);


                const paisesData = await geografiaFunciones.obtenerPaises();
                if (!isMounted) return;
                setPaises(paisesData);

                if (aprendizData.paisAprendiz) {
                    const estadosData = await geografiaFunciones.obtenerEstadosPorPais(aprendizData.paisAprendiz);
                    if (!isMounted) return;
                    setEstados(estadosData);
                }

                if (aprendizData.estadoAprendiz) {
                    const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(aprendizData.estadoAprendiz);
                    if (!isMounted) return;
                    setCiudades(ciudadesData);
                }

            } catch (error) {
                console.error("Error al obtener aprendiz:", error.message);
                if (error.response && !error.response.data.ok) {
                    Swal.fire({
                        icon: "error",
                        title: error.response.data.message,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            }
        };

        if (id) {
            fetchAprendiz();
        }

        return () => {
            isMounted = false; // evitar actualizar estado si el componente se desmonta
        };
    }, [id]);




    const cleanData = () => {
        setDocumentoAprendiz('');
        setTipodocumentoAprendiz('');
        setNombre1Aprendiz('');
        setNombre2Aprendiz('');
        setApellido1Aprendiz('');
        setApellido2Aprendiz('');
        setFechanacimientoAprendiz('');
        setEdadAprendiz('');
        setSexoAprendiz('');
        setRhAprendiz('');
        setEmailAprendiz('');
        setTelefono1Aprendiz('');
        setTelefono2Aprendiz('');
        setDireccionAprendiz('');
        setPaisAprendiz('');
        setEstadoAprendiz('');
        setCiudadAprendiz('');
        setPaisSeleccionado('');
        setEstadoSeleccionado('');
        setCiudadSeleccionada('');
        setPaises([]);
        setEstados([]);
        setCiudades([]);
        setImage('');
        setPreview('');

        // Limpiar estudiosAprendiz
        setEstudiosAprendiz([
            {
                nivel: '',
                institucion: '',
                tituloObtenido: '',
                anioFinalizacion: '',
                isAdding: false, // Reiniciar en modo edición
            },
        ]);

        // Limpiar acudientesAprendiz
        setAcudientesAprendiz([
            {
                nombreAcudiente: '',
                tipodocumentoAcudiente: '',
                documentoAcudiente: '',
                lugardocumentoAcudiente: '',
                relacionAcudiente: '',
                telefonoAcudiente: '',
                emailAcudiente: '',
                acudientePrincipal: '',
                isAdding: false, // Reiniciar en modo edición
            },
        ]);

        // Limpieza de imagen
        if (preview && preview.startsWith('blob:')) {
            try { URL.revokeObjectURL(preview); } catch (e) { }
        }
        setImage(null);
        setPreview('');
        previewRef.current = '';

        // Limpiar inputs auxiliares
        const fileInput = document.getElementById('fileInput');
        if (fileInput) fileInput.value = '';
        const fileNameInput = document.getElementById('fileName');
        if (fileNameInput) fileNameInput.value = '';
        const label = document.getElementById('fileLabel');
        if (label) label.textContent = 'Seleccionar Archivo';
    };

    // Función para guardar el aprendiz con la imagen
    const saveAprendiz = async (formData) => {
        try {
            setLoading(true);

            await axios.post('/api/Aprendices/add', formData, {
                // No pongas Content-Type, axios lo gestiona con boundary
                onUploadProgress: ({ loaded, total }) => {
                    const percent = parseInt((loaded * 100) / total);
                    setUploadState(percent);
                },
            });

            setLoading(false);
            cleanData();

            Swal.fire({
                icon: 'success',
                title: 'El Aprendiz ha sido registrado con éxito',
                showConfirmButton: false,
                timer: 1500,
            }).then(() => {
                navigate('/aprendiz/listaraprendices'); // Redirecciona después de la alerta
            });
        } catch (error) {
            setLoading(false);
            if (error.response?.data?.message) {
                return alert(error.response.data.message);
            }
            console.error('Error en saveAprendiz:', error.message);
        }
    };

    const updateAprendiz = async (formData) => {
        try {
            const { data } = await axios.put(`/api/aprendices/update/${id}`, formData, {
            });

            // Actualizar los estados con los valores del formulario enviado
            setFechanacimientoAprendiz(formData.get('fechanacimientoAprendiz'));
            setPaisSeleccionado(formData.get('paisAprendiz'));
            setEstadoSeleccionado(formData.get('estadoAprendiz'));
            setCiudadSeleccionada(formData.get('ciudadAprendiz'));

            Swal.fire({
                icon: 'success',
                title: data.message,
                showConfirmButton: false,
                timer: 1500
            }).then(() => navigate('/aprendiz/listaraprendices'));

        } catch (error) {
            console.error('Error en updateAprendiz', error);
            alert(error.response?.data?.message || "Error en la actualización");
        }
    };

    const actions = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // Imagen (si existe)
        if (image) {
            formData.append('imgAprendiz', image);
        }

        // Datos básicos del aprendiz
        const aprendizData = {
            "documentoAprendiz": documentoAprendiz,
            "tipodocumentoAprendiz": tipodocumentoAprendiz,
            "nombre1Aprendiz": nombre1Aprendiz,
            "nombre2Aprendiz": nombre2Aprendiz ?? "",
            "apellido1Aprendiz": apellido1Aprendiz,
            "apellido2Aprendiz": apellido2Aprendiz ?? "",
            "edadAprendiz": edadAprendiz ?? 0,
            "sexoAprendiz": sexoAprendiz ?? "",
            "direccionAprendiz": direccionAprendiz ?? "",
            "telefono1Aprendiz": telefono1Aprendiz,
            "telefono2Aprendiz": telefono2Aprendiz ?? "",
            "fechanacimientoAprendiz": fechanacimientoAprendiz ?? "",
            "rhAprendiz": rhAprendiz ?? "",
            "emailAprendiz": emailAprendiz,
            "paisAprendiz": paisAprendiz ?? 0,
            "estadoAprendiz": estadoAprendiz ?? 0,
            "ciudadAprendiz": ciudadAprendiz ?? 0
        };

        Object.entries(aprendizData).forEach(([key, value]) => formData.append(key, value));

        // Estudios (evita valores nulos o estructuras incorrectas)
        (Array.isArray(estudiosAprendiz) ? estudiosAprendiz : []).forEach((estudio, index) => {
            ["nivel", "institucion", "tituloObtenido", "anioFinalizacion"].forEach(field => {
                formData.append(`estudiosAprendiz[${index}][${field}]`, estudio?.[field] ?? "");
            });
        });

        // Acudientes (verifica si tienen un ID para actualizar)
        (Array.isArray(acudientesAprendiz) ? acudientesAprendiz.filter(Boolean) : []).forEach((acudiente, index) => {
            // Si existe, conserva su _id
            if (acudiente?._id) {
                formData.append(`acudientesAprendiz[${index}][_id]`, acudiente._id);
            }

            // Campos “normales”
            const fields = ["nombreAcudiente", "tipodocumentoAcudiente", "documentoAcudiente", "lugardocumentoAcudiente", "relacionAcudiente",
                "telefonoAcudiente", "emailAcudiente",];
            fields.forEach((f) => {
                formData.append(`acudientesAprendiz[${index}][${f}]`, acudiente?.[f] ?? "");
            });

            // Boolean como string (así lo espera tu backend)
            formData.append(
                `acudientesAprendiz[${index}][acudientePrincipal]`,
                acudiente?.acudientePrincipal ? "true" : "false"
            );

            // 👇 MUY IMPORTANTE: incluir firmaAcudiente y nameFirmaAcudiente si existen
            // para que el update del backend NO los borre
            if (acudiente?.firmaAcudiente) {
                formData.append(
                    `acudientesAprendiz[${index}][firmaAcudiente]`,
                    acudiente.firmaAcudiente
                );
            }
            if (acudiente?.nameFirmaAcudiente) {
                formData.append(
                    `acudientesAprendiz[${index}][nameFirmaAcudiente]`,
                    acudiente.nameFirmaAcudiente
                );
            }
        });

        // Determinar si es creación o actualización
        edit ? updateAprendiz(formData) : saveAprendiz(formData);
    };

    // Funciones para generar listas
    const edades = generarEdades();
    const sexos = generarSexos();
    const gruposSanguineos = generarGruposSanguineos();

    // Cargar países al montar el componente
    useEffect(() => {
        const cargarPaises = async () => {
            try {
                setPaises([]); // Reiniciar lista antes de cargar
                const paisesData = await geografiaFunciones.obtenerPaises();
                const paisesUnicos = paisesData.filter(
                    (pais, index, self) => index === self.findIndex(p => p.idPais === pais.idPais)
                );
                setPaises(paisesUnicos);
            } catch (error) {
                console.error("Error al cargar países:", error);
            }
        };

        cargarPaises();
    }, []);

    const handlePaisChange = async (paisId) => {
        try {
            setPaisSeleccionado(paisId);
            setPaisAprendiz(paisId);
            setEstados([]); // Reiniciar estados antes de cargar nuevos datos
            setCiudades([]);
            setEstadoSeleccionado('');
            setCiudadSeleccionada('');

            if (paisId) {
                const estadosData = await geografiaFunciones.obtenerEstadosPorPais(paisId);
                const estadosUnicos = estadosData.filter(
                    (estado, index, self) => index === self.findIndex(e => e.idEstado === estado.idEstado)
                );
                setEstados(estadosUnicos);
            }
        } catch (error) {
            console.error("Error al cambiar el país:", error);
        }
    };

    const handleEstadoChange = async (estadoId) => {
        try {
            setEstadoSeleccionado(estadoId);
            setEstadoAprendiz(estadoId);
            setCiudades([]); // Reiniciar ciudades antes de cargar nuevos datos
            setCiudadSeleccionada('');

            if (estadoId) {
                const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(estadoId);
                const ciudadesUnicas = ciudadesData.filter(
                    (ciudad, index, self) => index === self.findIndex(c => c.idCiudad === ciudad.idCiudad)
                );
                setCiudades(ciudadesUnicas);
            }
        } catch (error) {
            console.error("Error al cambiar el estado:", error);
        }
    };

    const handleCiudadChange = (ciudadId) => {
        setCiudadSeleccionada(ciudadId);
        setCiudadAprendiz(ciudadId); // Almacenar en ciudadAprendiz
    };

    // NUEVO: Manejo completo de archivo desde cámara (HEIC → JPEG + compresión)
    const handleFileChange = async (e) => {
        try {
            if (!e.target.files || !e.target.files[0]) return;
            const file = e.target.files[0];

            // Aceptamos extensiones e incluso si el tipo es image/*
            const isValidName =
                /\.(jpeg|jpg|png|svg|heic|heif)$/i.test(file.name || '');
            const isValidType = /image\//.test(file.type || '');
            if (!isValidName && !isValidType) {
                Swal.fire({
                    icon: 'error',
                    title: 'Archivo no válido',
                    text: 'Usa .jpg, .jpeg, .png (o HEIC en iPhone)',
                });
                e.target.value = '';
                return;
            }

            // Normaliza (convierte, comprime, corrige orientación)
            const processed = await normalizeImage(file);

            // Limpia URL previa si era blob
            if (preview && preview.startsWith('blob:')) {
                try { URL.revokeObjectURL(preview); } catch (err) { }
            }

            setImage(processed);
            const blobUrl = URL.createObjectURL(processed);
            setPreview(blobUrl);
            previewRef.current = blobUrl;

            // Actualiza UI auxiliar
            const label = document.getElementById('fileLabel');
            const fileNameInput = document.getElementById('fileName');
            if (fileNameInput) fileNameInput.value = processed.name || 'imagen.jpg';
            if (label) label.textContent = 'Cambiar Imagen';
        } catch (err) {
            console.error('Error procesando imagen:', err);
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo procesar la imagen.' });
        }
    };

    const agregarAcudiente = (event) => {
        event.preventDefault(); // Evita el envío de formulario si está dentro de un <form>

        if (acudientesAprendiz.length < 3) {
            const nuevoAcudiente = {
                nombreAcudiente: '',
                tipodocumentoAcudiente: '',
                documentoAcudiente: '',
                lugardocumentoAcudiente: '',
                relacionAcudiente: '',
                telefonoAcudiente: '',
                emailAcudiente: '',
                acudientePrincipal: acudientesAprendiz.length === 0, // El primero es principal
            };

            setAcudientesAprendiz([...acudientesAprendiz, nuevoAcudiente]);
        }
    };

    const eliminarAcudiente = (index) => {
        const nuevosAcudientes = acudientesAprendiz.filter((_, i) => i !== index);
        setAcudientesAprendiz(nuevosAcudientes);
    };

    const handleAcudienteChange = (index, event) => {
        const { name, value, type, checked } = event.target;
        const nuevosAcudientes = [...acudientesAprendiz];

        if (name === "acudientePrincipal" && checked) {
            // Solo uno puede ser principal: desmarcamos todos y marcamos solo el actual
            nuevosAcudientes.forEach((acudiente, i) => {
                nuevosAcudientes[i].acudientePrincipal = (i === index);
            });
        } else {
            // Para otros cambios, simplemente actualizamos el valor
            nuevosAcudientes[index] = {
                ...nuevosAcudientes[index],
                [name]: type === "checkbox" ? checked : value
            };
        }

        setAcudientesAprendiz(nuevosAcudientes);
    };


    const agregarEstudio = (event) => {
        event.preventDefault(); // Evita el envío del formulario si está dentro de un <form>

        const nuevoEstudio = {
            nivel: "",
            institucion: "",
            tituloObtenido: "",
            anioFinalizacion: "",
        };

        setEstudiosAprendiz([...estudiosAprendiz, nuevoEstudio]);
    };

    const eliminarEstudio = (index) => {
        const nuevosEstudios = estudiosAprendiz.filter((_, i) => i !== index);
        setEstudiosAprendiz(nuevosEstudios);
    };

    const handleEstudioChange = (index, event) => {
        const { name, value } = event.target;
        const nuevosEstudios = [...estudiosAprendiz];

        nuevosEstudios[index] = {
            ...nuevosEstudios[index],
            [name]: value
        };

        setEstudiosAprendiz(nuevosEstudios);
    };



    // 👇 permite elegir a cuál acudiente le vemos/registramos la firma
    const [selectedAcudienteId, setSelectedAcudienteId] = useState(null);

    // principal: el marcado como principal o el primero disponible
    const acudientePrincipal = useMemo(() => {
        if (!Array.isArray(acudientesAprendiz)) return null;
        return (
            acudientesAprendiz.find(a => a?.acudientePrincipal) ||
            acudientesAprendiz[0] ||
            null
        );
    }, [acudientesAprendiz]);

    // el “actual”: si hay uno seleccionado, úsalo; si no, toma el principal
    const acudienteActual = useMemo(() => {
        if (!Array.isArray(acudientesAprendiz)) return null;
        if (selectedAcudienteId) {
            return acudientesAprendiz.find(a => String(a?._id) === String(selectedAcudienteId)) || null;
        }
        return acudientePrincipal;
    }, [acudientesAprendiz, selectedAcudienteId, acudientePrincipal]);

    // establece seleccionado por defecto cuando llegan los acudientes
    useEffect(() => {
        if (!selectedAcudienteId) {
            if (acudientePrincipal?._id) setSelectedAcudienteId(acudientePrincipal._id);
            else if (acudientesAprendiz?.[0]?._id) setSelectedAcudienteId(acudientesAprendiz[0]._id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acudientesAprendiz]);

    // actualiza el preview cuando cambie el acudiente actual
    useEffect(() => {
        if (acudienteActual?.firmaAcudiente) {
            setPreviewFirmaAcudiente(acudienteActual.firmaAcudiente);
        } else {
            setPreviewFirmaAcudiente(null);
        }
    }, [acudienteActual]);

    return (
        <div className="container-fluid px-0 shadow-lg rounded-4 bg-light mb-5 ">
            < div className='container py-4' >
                <h1>Registrar Aprendices</h1>
            </div>

            < div className='container' >
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="datos-tab" data-bs-toggle="tab" data-bs-target="#datos" type="button" role="tab">
                            Personal
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="familia-tab" data-bs-toggle="tab" data-bs-target="#familia" type="button" role="tab">
                            Familiar
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="estudios-tab" data-bs-toggle="tab" data-bs-target="#estudios" type="button" role="tab">
                            Estudios
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="firmaaprendiz-tab" data-bs-toggle="tab" data-bs-target="#firmaaprendiz" type="button" role="tab">
                            Firma Aprendiz
                        </button>
                    </li>

                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="firmaacudiente-tab" data-bs-toggle="tab" data-bs-target="#firmaacudiente" type="button" role="tab">
                            Firma Acudiente
                        </button>
                    </li>
                </ul>
            </div>

            <div className='mb-5'>
                <form onSubmit={actions}>
                    <div className="container">
                        <div className="tab-content mt-3" id="myTabContent">
                            <div className="tab-pane fade show active" id="datos" role="tabpanel" aria-labelledby="datos-tab">

                                {/* Fila que contiene dos columnas */}
                                <div className="row">
                                    {/* Columna izquierda: datos del docente */}
                                    <div className="col-md-9">
                                        {/* Datos del docente */}
                                        <div className="row">
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="nombre1" className="form-label  mt-3 mb-2 ">Nombre 1</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="nombre1"
                                                    placeholder="Ingrese su segundo nombre"
                                                    value={nombre1Aprendiz} // Asociado al estado
                                                    onChange={(e) => setNombre1Aprendiz(e.target.value)}
                                                    required
                                                />

                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="nombre2" className="form-label  mt-3 mb-2 ">Nombre 2</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="nombre2"
                                                    placeholder="Ingrese su segundo nombre"
                                                    value={nombre2Aprendiz}
                                                    onChange={(e) => setNombre2Aprendiz(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-12 col-md-3">
                                                <label htmlFor="apellido1" className="form-label  mt-3 mb-2">Apellido 1</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="apellido1"
                                                    placeholder="Ingrese su primer apellido"
                                                    value={apellido1Aprendiz}
                                                    onChange={(e) => setApellido1Aprendiz(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="apellido2" className="form-label  mt-3 mb-2">Apellido 2</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="apellido2"
                                                    placeholder="Ingrese su segundo apellido"
                                                    value={apellido2Aprendiz}
                                                    onChange={(e) => setApellido2Aprendiz(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="tipoDocumento" className="form-label mt-3 mb-2">Tipo de Documento</label>
                                                <select
                                                    className="form-control"
                                                    id="tipoDocumento"
                                                    value={tipodocumentoAprendiz}
                                                    onChange={(e) => setTipodocumentoAprendiz(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccione un tipo</option>
                                                    <option value="CC">Cédula de Ciudadanía</option>
                                                    <option value="TI">Tarjeta de Identidad</option>
                                                    <option value="CE">Cédula de Extranjería</option>
                                                    <option value="PAS">Pasaporte</option>
                                                </select>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="numeroDocumento" className="form-label mt-3 mb-2">Número de Documento</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="numeroDocumento"
                                                    placeholder="Ingrese su número de documento"
                                                    value={documentoAprendiz}
                                                    onChange={(e) => setDocumentoAprendiz(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="direccion" className="form-label  mt-3 mb-2">Dirección</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="direccion"
                                                    placeholder="Ingrese su dirección"
                                                    value={direccionAprendiz}
                                                    onChange={(e) => setDireccionAprendiz(e.target.value)}

                                                />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="telefono1" className="form-label  mt-3 mb-2">Teléfono 1</label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    id="telefono1"
                                                    placeholder="Ingrese su número de teléfono1"
                                                    value={telefono1Aprendiz}
                                                    onChange={(e) => setTelefono1Aprendiz(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="col-12 col-md-3">
                                                <label htmlFor="telefono2" className="form-label  mt-3 mb-2">Teléfono 2</label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    id="telefono2"
                                                    placeholder="Ingrese su número de teléfono2"
                                                    value={telefono2Aprendiz}
                                                    onChange={(e) => setTelefono2Aprendiz(e.target.value)}

                                                />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label htmlFor="email" className="form-label  mt-3 mb-2">Correo Electrónico</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="email"
                                                    placeholder="Ingrese su correo electrónico"
                                                    value={emailAprendiz}
                                                    onChange={(e) => setEmailAprendiz(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="fechanacimiento" className="form-label  mt-3 mb-2 ">Fecha de Nacimiento</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="fechanacimiento"
                                                    value={fechanacimientoAprendiz}
                                                    onChange={(e) => setFechanacimientoAprendiz(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="edad" className="form-label  mt-3 mb-2 ">Edad</label>
                                                <select
                                                    className="form-control"
                                                    value={edadAprendiz}
                                                    onChange={(e) => setEdadAprendiz(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccione una edad</option>
                                                    {edades.map((edad) => (
                                                        <option key={edad} value={edad}>
                                                            {edad}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="sexo" className="form-label  mt-3 mb-2 ">Sexo</label>
                                                <select
                                                    id="sexo"
                                                    className="form-control"
                                                    value={sexoAprendiz}
                                                    onChange={(e) => setSexoAprendiz(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccione un sexo</option>
                                                    {sexos.map((sexo, index) => (
                                                        <option key={index} value={sexo.valor}>
                                                            {sexo.etiqueta}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <label htmlFor="rh" className="form-label  mt-3 mb-2 ">RH</label>
                                                <select
                                                    id="grupoSanguineo"
                                                    className="form-control"
                                                    value={rhAprendiz}
                                                    onChange={(e) => setRhAprendiz(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccione un grupo sanguíneo</option>
                                                    {gruposSanguineos.map((grupo) => (
                                                        <option key={grupo} value={grupo}>
                                                            {grupo}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <label htmlFor="pais" className="form-label mt-3 mb-2">País</label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => handlePaisChange(e.target.value)}
                                                    value={paisSeleccionado || paisAprendiz || ""}
                                                >
                                                    <option value="">Seleccione un país</option>
                                                    {Array.isArray(paises) && paises.length > 0 ? (
                                                        paises.map((pais) => (
                                                            <option key={pais.idPais} value={pais.idPais}>
                                                                {pais.nombrePais}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>Cargando países...</option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label htmlFor="estado" className="form-label mt-3 mb-2">Estado</label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => handleEstadoChange(e.target.value)}
                                                    value={estadoSeleccionado || estadoAprendiz || ""}
                                                    disabled={!paisSeleccionado} // Evita seleccionar si no hay país
                                                >
                                                    <option value="">Seleccione un estado</option>
                                                    {Array.isArray(estados) && estados.length > 0 ? (
                                                        estados.map((estado) => (
                                                            <option key={estado.idEstado} value={estado.idEstado}>
                                                                {estado.nombreEstado}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>{paisSeleccionado ? "Cargando estados..." : "Seleccione un país primero"}</option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label htmlFor="ciudad" className="form-label mt-3 mb-2">Ciudad</label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => handleCiudadChange(e.target.value)}
                                                    value={ciudadSeleccionada || ciudadAprendiz || ""}
                                                    disabled={!estadoSeleccionado} // Evita seleccionar si no hay estado
                                                >
                                                    <option value="">Seleccione una ciudad</option>
                                                    {Array.isArray(ciudades) && ciudades.length > 0 ? (
                                                        ciudades.map((ciudad) => (
                                                            <option key={ciudad.idCiudad} value={ciudad.idCiudad}>
                                                                {ciudad.nombreCiudad}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>{estadoSeleccionado ? "Cargando ciudades..." : "Seleccione un estado primero"}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-3 text-end">
                                        <label htmlFor="foto" className="form-label text-center w-100 mt-3 mb-2">
                                            Foto
                                        </label>

                                        <div className="col-md-12">
                                            {/* Vista previa de la imagen */}
                                            <div
                                                className="card-img-top bg-light d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: '100%',
                                                    height: '280px',
                                                    border: '1px dashed #ccc',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                {preview !== '' ? (
                                                    <img
                                                        src={preview}
                                                        className="img-fluid"
                                                        alt="Vista previa"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover', // "cover" para que la imagen ocupe todo el espacio sin distorsión
                                                        }}
                                                    />
                                                ) : (
                                                    <span className="text-muted">Vista previa</span>
                                                )}
                                            </div>

                                            {/* Selector de archivo */}
                                            <div className="d-grid gap-2 mt-3">
                                                {/* Input de archivo oculto */}
                                                {/* Input de archivo para cámara/galería */}
                                                <input
                                                    type="file"
                                                    id="fileInput"
                                                    name="imgInstructor"
                                                    className="d-none"
                                                    accept="image/*"
                                                    capture="environment"
                                                    onChange={handleFileChange}
                                                />


                                                {/* Campo para mostrar el nombre del archivo */}
                                                <input
                                                    type="text"
                                                    id="fileName"
                                                    className="form-control text-muted"
                                                    placeholder="Ningún archivo seleccionado"
                                                    readOnly
                                                />

                                                {/* Botón de selección de archivo con texto dinámico */}
                                                <label
                                                    id="fileLabel"
                                                    htmlFor="fileInput"
                                                    className="btn btn-primary btn-sm w-100 mt-2"
                                                >
                                                    Seleccionar Archivo
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="tab-pane fade" id="familia" role="tabpanel">
                                <div>
                                    <div className="row">
                                        {acudientesAprendiz.length > 0 ? (
                                            acudientesAprendiz.map((acudiente, index) => (
                                                <div key={index} className="col-md-4">
                                                    <div className="card shadow-sm bg-transparent mb-3">
                                                        <div className="card-body">
                                                            <h5 className="card-title text-center fw-bold text-muted">
                                                                {acudiente.acudientePrincipal
                                                                    ? "Acudiente Principal"
                                                                    : `Acudiente ${index + 1}`}
                                                            </h5>
                                                            <hr />
                                                            <div className="mb-3">
                                                                <label className="form-label text-muted">
                                                                    Nombre Completo
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="nombreAcudiente"
                                                                    value={acudiente.nombreAcudiente || ""}
                                                                    placeholder="Ejemplo: Carlos Rodríguez"
                                                                    onChange={(event) => handleAcudienteChange(index, event)}
                                                                />
                                                            </div>

                                                            <div className="row g-2">
                                                                <div className="col-md-6">
                                                                    <label className="form-label text-muted">
                                                                        Tipo Documento
                                                                    </label>
                                                                    <select
                                                                        className="form-control"
                                                                        name="tipodocumentoAcudiente"
                                                                        value={acudiente.tipodocumentoAcudiente || ""}
                                                                        onChange={(event) => handleAcudienteChange(index, event)}
                                                                    >
                                                                        <option value="">Seleccione tipo</option>
                                                                        <option value="CC">CC</option>
                                                                        <option value="CE">CE</option>
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label text-muted">Documento</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        name="documentoAcudiente"
                                                                        value={acudiente.documentoAcudiente || ""}
                                                                        placeholder="3204567890"
                                                                        onChange={(event) => handleAcudienteChange(index, event)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="mb-3 mt-2">
                                                                <label className="form-label text-muted">
                                                                    Lugar de Expedición
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="lugardocumentoAcudiente"
                                                                    value={acudiente.lugardocumentoAcudiente || ""}
                                                                    placeholder="Ejemplo: Medellín, Antioquia"
                                                                    onChange={(event) => handleAcudienteChange(index, event)}
                                                                />
                                                            </div>

                                                            <div className="row g-2">
                                                                <div className="col-md-6">
                                                                    <label className="form-label text-muted">Relación</label>
                                                                    <select
                                                                        className="form-control"
                                                                        name="relacionAcudiente"
                                                                        value={acudiente.relacionAcudiente || ""}
                                                                        onChange={(event) => handleAcudienteChange(index, event)}
                                                                    >
                                                                        <option value="">Seleccione relación</option>
                                                                        <option value="Padre">Padre</option>
                                                                        <option value="Madre">Madre</option>
                                                                        <option value="Abuelo">Abuelo(a)</option>
                                                                        <option value="Tío">Tío(a)</option>
                                                                        <option value="Primo">Primo(a)</option>
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label text-muted">Teléfono</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        name="telefonoAcudiente"
                                                                        value={acudiente.telefonoAcudiente || ""}
                                                                        placeholder="Ejemplo: 3204567890"
                                                                        onChange={(event) => handleAcudienteChange(index, event)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="mb-3 mt-2">
                                                                <label className="form-label text-muted">Email</label>
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    name="emailAcudiente"
                                                                    value={acudiente.emailAcudiente || ""}
                                                                    placeholder="Ejemplo: usuario@gmail.com"
                                                                    onChange={(event) => handleAcudienteChange(index, event)}
                                                                />
                                                            </div>

                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        name="acudientePrincipal"
                                                                        checked={!!acudiente.acudientePrincipal}
                                                                        onChange={(event) => handleAcudienteChange(index, event)}
                                                                    />
                                                                    <label className="form-check-label text-muted">
                                                                        Acudiente Principal
                                                                    </label>
                                                                </div>

                                                                {acudiente.acudientePrincipal && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() => navegarFirmaAcudiente(acudiente._id)}
                                                                    >
                                                                        Agregar Firma
                                                                    </button>
                                                                )}

                                                                {acudientesAprendiz.length > 1 && (
                                                                    <button
                                                                        className="btn btn-link p-0 border-0 text-danger"
                                                                        onClick={() => eliminarAcudiente(index)}
                                                                    >
                                                                        <i className="fas fa-trash"></i>
                                                                    </button>
                                                                )}
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center text-muted">
                                                No hay acudientes registrados.
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <button
                                        className="btn btn-primary w-100 mt-3"
                                        onClick={agregarAcudiente}
                                        disabled={acudientesAprendiz.length >= 3}
                                        type="button"
                                    >
                                        Agregar Acudiente
                                    </button>
                                </div>
                            </div>




                            <div className="tab-pane fade" id="estudios" role="tabpanel">
                                <div>
                                    {estudiosAprendiz.length > 0 ? (
                                        estudiosAprendiz.map((estudio, index) => (
                                            <div key={index} className="card shadow-sm border-0 mb-3">
                                                <div className="card-body">
                                                    <div className="row g-2">
                                                        <div className="col-md-2">
                                                            <label className="form-label fw-semibold">Nivel</label>
                                                            <select
                                                                className="form-select"
                                                                name="nivel"
                                                                value={estudio.nivel}
                                                                onChange={(event) => handleEstudioChange(index, event)}
                                                            >
                                                                <option value="">Seleccione un nivel</option>
                                                                <option value="Bachiller">Bachiller</option>
                                                                <option value="Técnico">Técnico</option>
                                                                <option value="Tecnólogo">Tecnólogo</option>
                                                                <option value="Pregrado">Pregrado</option>
                                                                <option value="Posgrado">Posgrado</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-12 col-md-4">
                                                            <label className="form-label fw-semibold">Institución</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="institucion"
                                                                value={estudio.institucion}
                                                                placeholder="Ejemplo: Universidad Nacional"
                                                                onChange={(event) => handleEstudioChange(index, event)}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <label className="form-label fw-semibold">Título Obtenido</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="tituloObtenido"
                                                                value={estudio.tituloObtenido}
                                                                placeholder="Ejemplo: Ingeniero Civil"
                                                                onChange={(event) => handleEstudioChange(index, event)}
                                                            />
                                                        </div>
                                                        <div className="col-md-1">
                                                            <label className="form-label fw-semibold">Año</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                name="anioFinalizacion"
                                                                value={estudio.anioFinalizacion}
                                                                placeholder="Ej: 2023"
                                                                min="1900"
                                                                max={new Date().getFullYear()}
                                                                onChange={(event) => handleEstudioChange(index, event)}
                                                            />
                                                        </div>
                                                        <div className="col-md-1 d-flex align-items-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-link p-0 border-0 text-danger"
                                                                onClick={() => eliminarEstudio(index)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-center text-muted">No hay estudios registrados.</p>
                                    )}
                                </div>
                                <div>
                                    <button type="button" className="btn btn-primary w-100 mt-3" onClick={agregarEstudio}>
                                        Agregar Estudio
                                    </button>
                                </div>
                            </div>



                            <div className="tab-pane fade" id="firmaaprendiz" role="tabpanel">
                                <div className="text-center">
                                    <h5>Firma del Aprendiz</h5>

                                    {/* Vista previa de la firma si existe */}
                                    <div
                                        className="card-img-top bg-light d-flex align-items-center justify-content-center my-3"
                                        style={{
                                            width: '400px',
                                            height: '150px',
                                            border: '1px dashed #ccc',
                                            margin: '0 auto',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {previewFirmaAprendiz ? (
                                            <img
                                                src={previewFirmaAprendiz}
                                                alt="Firma del aprendiz"
                                                className="img-fluid"
                                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                            />
                                        ) : (
                                            <span className="text-muted">No hay firma registrada</span>
                                        )}
                                    </div>


                                    <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        onClick={() =>
                                            aprendiz && aprendiz._id
                                                ? navigate(`/aprendiz/registrarfirma/${aprendiz._id}`)
                                                : alert("No se encontró el aprendiz")
                                        }
                                    >
                                        Registrar Firma
                                    </button>
                                </div>
                            </div>

                            <div className="tab-pane fade" id="firmaacudiente" role="tabpanel">
                                <div className="text-center">
                                    <h5>Firma del Acudiente</h5>

                                    {/* (Opcional) selector si hay varios acudientes */}
                                    {acudientesAprendiz?.length > 1 && (
                                        <div className="mb-3" style={{ maxWidth: 400, margin: "0 auto" }}>
                                            <select
                                                className="form-select"
                                                value={selectedAcudienteId || ""}
                                                onChange={(e) => setSelectedAcudienteId(e.target.value)}
                                            >
                                                {acudientesAprendiz.map(a => (
                                                    <option key={a._id || `tmp-${Math.random()}`} value={a._id || ""}>
                                                        {a?.acudientePrincipal ? "Acudiente Principal" : (a?.nombreAcudiente || "Acudiente")}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    {/* Vista previa */}
                                    <div
                                        className="card-img-top bg-light d-flex align-items-center justify-content-center my-3"
                                        style={{
                                            width: "400px",
                                            height: "150px",
                                            border: "1px dashed #ccc",
                                            margin: "0 auto",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {previewFirmaAcudiente ? (
                                            <img
                                                src={previewFirmaAcudiente}
                                                alt="Firma del acudiente"
                                                className="img-fluid"
                                                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                            />
                                        ) : (
                                            <span className="text-muted">No hay firma registrada</span>
                                        )}
                                    </div>

                                    <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        onClick={() => acudienteActual?._id && navegarFirmaAcudiente(acudienteActual._id)}
                                        disabled={!acudienteActual?._id}
                                    >
                                        Agregar Firma
                                    </button>
                                </div>
                            </div>

                            {/* Botón de envío */}
                            <div className="col-12 mt-4 mb-5">
                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <button type="submit" className="btn btn-success w-100">
                                            {edit ? 'Actualizar' : 'Enviar'}
                                        </button>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <button
                                            type="button"
                                            className={`btn w-100 ${edit ? 'btn-danger' : 'btn-secondary'}`}
                                            onClick={handleCancelOrClean}
                                        >
                                            {edit ? 'Cancelar' : 'Limpiar'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>

            <div>
                {loading && (
                    <div className="progress">
                        <div
                            className="progress-bar bg-primary"
                            role="progressbar"
                            style={{ width: `${uploadState}%` }}
                        ></div>
                    </div>
                )}
            </div>
        </div>

    )
}

export default RegistrarAprendices